import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { TextReplaceService } from '../services/text-replace.service';

@Injectable({ providedIn: 'root' })
@Pipe({
  name: 'replaceText',
  standalone: true,
  pure: false
})
export class ReplaceTextPipe implements PipeTransform {

  constructor(private textReplace: TextReplaceService) { }

  transform(value: string): string {
    return this.textReplace.replace(value);
  }
}
